<div class="hitmaker_image_new" fxLayout="column wrap">
    <img class="image1" src="../../../../assets/images/CreateYourDream.jpg">
</div>
<div fxLayout="column" fxHide.xs fxFlexAlign="center" class="align-items-center mt-3">
    <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="20" class="gap-3">
        <div class="mt-2"><iframe width="445" height="224" src="https://www.youtube.com/embed/itLHx92iRqw"
                title="7 Powers Of Creating" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe></div>
        <div class="mt-2">
            <iframe width="446" height="224" src="https://www.youtube.com/embed/luF9pw4MtaI" title="Creating Your Life"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

        </div>
    </div>
    <div fxLayout="row mt-2" fxLayout.sm="column" fxLayout.xs="column" class="gap-3">
        <div class="mt-2"><img src="../../../../assets/images/7powers_amazon2.jpg" style="    width: 446px;
                height: 224px;"   (click)="navigateUrl('https://www.amazon.com/7-Powers-Creating-Halfdan-Hussey-ebook/dp/B00BBRULTG/154-0845260-7017704')"></div>
        <div class="mt-2 "><img src="../../../../assets/images/7powers_itunes2.jpg" style="    width: 446px;
                height: 224px;"   (click)="navigateUrl('https://books.apple.com/us/book/7-powers-of-creating/id601159877')"><a href=""></a></div>
    </div>
</div>
<div fxLayout="column" fxHide.sm fxHide.lg fxHide.md fxHide.xl class="align-items-center ">
    <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
        <div class="mt-2"><iframe width="366" height="190" src="https://www.youtube.com/embed/itLHx92iRqw"
                title="7 Powers Of Creating" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe></div>
        <div class="mt-2">
            <iframe width="366" height="190" src="https://www.youtube.com/embed/luF9pw4MtaI" title="Creating Your Life"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

        </div>
    </div>
    <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
        <div class="mt-2"><img src="../../../../assets/images/7powers_amazon2.jpg"
                (click)="navigateUrl('https://www.amazon.com/7-Powers-Creating-Halfdan-Hussey-ebook/dp/B00BBRULTG/154-0845260-7017704')"
                style="width: 366px;height: 190px;cursor: pointer;"></div>
        <div class="mt-2 "><img
                (click)="navigateUrl('https://books.apple.com/us/book/7-powers-of-creating/id601159877')"
                src="../../../../assets/images/7powers_itunes2.jpg" style="width: 366px;height:190px;cursor: pointer;"></div>
    </div>
</div>

<div class="sub-container">
    <h1>7 POWERS OF CREATING
    </h1>
</div>
<div fxLayout='column' class="flex align-items-center justify-content-center gap-3 mb-2">
    <div fxLayout="row" fxLayout.xs='column' class="gap-3"
        class="flex align-items-center justify-content-center  gap-3">
        <div fxFlex="18" fxFlex.sm="21" class="flex align-items-center justify-content-center sub-cards">
            <img [src]="powerItems[0].image">
            <h3 class="mt-1 mb-0">{{powerItems[0].title}}</h3>
            <h4>{{powerItems[0].description}}</h4>
        </div>
        <div fxFlex="18" fxFlex.sm="21" class="flex align-items-center justify-content-center sub-cards">
            <img [src]="powerItems[1].image">
            <h3 class="mt-1 mb-0">{{powerItems[1].title}}</h3>
            <h4>{{powerItems[1].description}}</h4>
        </div>
        <div fxFlex="18" fxFlex.sm="21" class="flex align-items-center justify-content-center sub-cards">
            <img [src]="powerItems[2].image">
            <h3 class="mt-1 mb-0">{{powerItems[2].title}}</h3>
            <h4>{{powerItems[2].description}}</h4>
        </div>
        <div fxFlex="18" fxFlex.sm="21" class="flex align-items-center justify-content-center sub-cards">
            <img [src]="powerItems[3].image">
            <h3 class="mt-1 mb-0">{{powerItems[3].title}}</h3>
            <h4>{{powerItems[3].description}}</h4>
        </div>
    </div>
    <div fxLayout="row" fxLayout.xs='column' class="flex align-items-center justify-content-center  gap-3 mt-3">
        <div fxFlex="19" fxFlex.sm="21" class="flex align-items-center justify-content-center sub-cards">
            <img [src]="powerItems[4].image">
            <h3 class="mt-1 mb-0">{{powerItems[4].title}}</h3>
            <h4>{{powerItems[4].description}}</h4>
        </div>
        <div fxFlex="19" fxFlex.sm="21" class="flex align-items-center justify-content-center sub-cards">
            <img [src]="powerItems[5].image">
            <h3 class="mt-1 mb-0">{{powerItems[5].title}}</h3>
            <h4>{{powerItems[5].description}}</h4>
        </div>
        <div fxFlex="19" fxFlex.sm="21" class="flex align-items-center justify-content-center sub-cards">
            <img [src]="powerItems[6].image">
            <h3 class="mt-1 mb-0">{{powerItems[6].title}}</h3>
            <h4>{{powerItems[6].description}}</h4>
        </div>
    </div>
</div>